import React from "react";
import { motion } from "framer-motion";
import { Heart, ShieldCheck, CreditCard, Lock, Check } from "lucide-react";
import CheckoutButton from "./CheckoutButton";

const CLOSING_IMG = "/img/closing-family.webp";

const PILLARS = [
  { icon: Heart, label: "Familia saludable" },
  { icon: ShieldCheck, label: "Menos estrés diario" },
  { icon: CreditCard, label: "Más organización" },
];

export default function FinalCTA() {
  return (
    <section
      data-testid="final-cta-section"
      className="relative bg-[#2A302A] py-24 md:py-36 overflow-hidden"
    >
      <div className="absolute inset-0 grain opacity-30 pointer-events-none" />
      <img loading="lazy" decoding="async"
        src={CLOSING_IMG}
        alt=""
        aria-hidden="true"
        className="absolute inset-0 w-full h-full object-cover opacity-20 mix-blend-luminosity"
      />
      <div
        className="absolute -inset-32 opacity-30"
        style={{
          background:
            "radial-gradient(60% 50% at 50% 40%, rgba(132,153,131,0.6) 0%, rgba(132,153,131,0) 70%)",
        }}
      />

      <div className="relative max-w-4xl mx-auto px-6 text-center">
        <p className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#C8A892]">
          Última llamada
        </p>
        <motion.h2
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.8 }}
          className="mt-4 font-serif-display text-4xl md:text-6xl lg:text-7xl tracking-tight leading-[1.04] text-[#FDFBF7]"
        >
          Tu familia merece{" "}
          <em className="italic text-[#C8A892]">comidas saludables</em> sin estrés.
        </motion.h2>
        <p className="mt-7 text-base md:text-lg leading-relaxed text-white/80 max-w-2xl mx-auto">
          Hoy puedes elegir una nueva forma de cocinar: con tranquilidad, organización
          y amor. Tus hijos se merecen lo mejor. Y tú también.
        </p>

        {/* Price reveal */}
        <div className="mt-10 inline-flex flex-col items-center gap-2 bg-white/8 backdrop-blur-sm border border-white/15 rounded-3xl px-8 py-6">
          <span className="text-[11px] tracking-[0.22em] uppercase font-semibold text-[#C8A892]">
            Hoy acceso completo por solo
          </span>
          <div className="flex items-baseline gap-3">
            <span className="font-serif-display text-5xl md:text-6xl text-white leading-none">
              USD 9.90
            </span>
            <span className="text-white/50 line-through text-base">USD 87</span>
          </div>
          <ul className="mt-4 space-y-1.5 text-left">
            <li className="flex items-center gap-2 text-[13px] text-white/85">
              <Check className="h-3.5 w-3.5 text-[#C8A892]" strokeWidth={2.6} />
              Ebook + 4 bonos exclusivos
            </li>
            <li className="flex items-center gap-2 text-[13px] text-white/85">
              <Check className="h-3.5 w-3.5 text-[#C8A892]" strokeWidth={2.6} />
              Acceso inmediato
            </li>
            <li className="flex items-center gap-2 text-[13px] text-white/85">
              <Check className="h-3.5 w-3.5 text-[#C8A892]" strokeWidth={2.6} />
              Oferta de lanzamiento USD 9.90
            </li>
          </ul>
        </div>

        <div className="mt-8 flex flex-col items-center gap-5">
          <CheckoutButton
            label="SÍ, QUIERO ALIMENTAR MEJOR A MI HIJO"
            testId="final-cta-button"
            size="xxl"
            fullWidthMobile
          />
          <div className="flex flex-wrap items-center justify-center gap-x-5 gap-y-2 text-[11px] text-white/65">
            <span className="inline-flex items-center gap-1.5">
              <Lock className="h-3 w-3" /> Pago 100% seguro
            </span>
            <span className="inline-flex items-center gap-1.5">
              <ShieldCheck className="h-3 w-3" /> Acceso inmediato
            </span>
            <span className="inline-flex items-center gap-1.5">
              <CreditCard className="h-3 w-3" /> Móvil · Tablet · PC
            </span>
          </div>
        </div>

        {/* Emotional pillars */}
        <div className="mt-16 grid grid-cols-3 gap-6 max-w-2xl mx-auto">
          {PILLARS.map((p, i) => (
            <motion.div
              key={p.label}
              initial={{ opacity: 0, y: 12 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: 0.1 + i * 0.1 }}
              className="flex flex-col items-center text-center gap-2"
            >
              <div className="w-11 h-11 rounded-full bg-white/8 border border-white/15 flex items-center justify-center backdrop-blur">
                <p.icon className="h-4 w-4 text-[#C8A892]" strokeWidth={1.6} />
              </div>
              <span className="text-[11px] tracking-wide text-white/70">{p.label}</span>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
